import { connect } from 'react-redux'
import { getSetting } from './actions'
import Setting from './main'


const mapDispatchToProps = {
  getSetting
}
const mapStateToProps = (state) => {
  return {
    ...state.SettingList
  }
}
  

export default connect(mapStateToProps, mapDispatchToProps)(Setting)
